import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import Input from '../input/Input';
import Label from '../other/label';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { axios } from 'axios';

const header = () => (
    <h3 className="p-col-12 p-md-12 text-center">
        <i className="pi pi-user" />Organization Details
    </h3>);

const footer = () => (
    <div className="p-grid">
        <div className="p-col-12 p-md-5">
            <Button className="p-button-text" label="Back" />
        </div>
        <div className="p-col-12 p-md-2">
            <Button className="p-button-secondary" label="Save" />
        </div>
        <div className="p-col-12 p-md-3">
        </div>
        <div className="p-col-12 p-md-2">
            <Button className="pull-right" label="Next" />
        </div>
    </div>);

function OrganizationLookup() {
    const { t } = useTranslation();



    const organizationLookup = {
        dpId: '',
        organizationName: '',
        organizationAddress: ''
    }

    const onSubmit = (data) => {
        console.log(data);
        //   setFormData(data);
        //   setShowMessage(true);
        axios.post('localhost:9003/security/organization', data)
            .then((response) => { console.log(response.data) });



    };

    const { control, formState: { errors }, handleSubmit, reset } = useForm({ organizationLookup });

    return (
        <Card className="p-col-12 p-md-12"
            header={header}
        // footer={footer}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                <div className="p-grid p-fluid">
                    <div className="p-field p-col-12 p-md-4 stick-right">
                        <label className="p-col-12 p-md-12" htmlFor="dpId">
                            <Label text="KYC AGENT" textNep="KYC AGENT" /></label>
                        <div className="p-inputgroup">
                            <Controller name="dpId" control={control} rules={{ required: 'Name is required.' }} render={({ field, fieldState }) => (
                                <Input id={field.name} {...field} placeholder={t('dpId')} />
                            )} />
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4 stick-left stick-right">
                        <label className="p-col-12 p-md-12" htmlFor="organizationName">
                            <Label text="Organization Name" textNep="Organization Name" /></label>
                        <div className="p-inputgroup">
                            <Controller name="organizationName" control={control} rules={{ required: 'Organization Name is required.' }} render={({ field, fieldState }) => (
                                <Input id={field.name} {...field} placeholder={t('organizationName')} />
                            )} />
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4 stick-left">
                        <label className="p-col-12 p-md-12" htmlFor="organizationAddress">
                            <Label text="Organization Address" textNep="Organization Address" /></label>
                        <div className="p-inputgroup">
                            <Controller name="organizationAddress" control={control} rules={{ required: 'Organization Address is required.' }} render={({ field, fieldState }) => (
                                <Input id={field.name} {...field} placeholder={t('orgAddress')} />
                            )} />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button type="submit" label="Submit" className="pull-right" />
                    </div>
                </div>

            </form>
        </Card>
    );
}

export default OrganizationLookup;
